import script from "./MarkdownRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkdownRenderer.vue?vue&type=script&setup=true&lang=js"

import "./MarkdownRenderer.vue?vue&type=style&index=0&id=1f704d0c&lang=postcss"

const __exports__ = script;

export default __exports__